export default {
  setAboutCompany(state, about) {
    state.aboutCompany = about;
  },
};
